import React from 'react';
import { SunriseIcon, BrainIcon, TrophyIcon, BoxIcon } from 'lucide-react';
export function Experience() {
  const timeline = [{
    day: 'Day 0',
    title: 'Arrival & Reset',
    duration: '4 hours',
    icon: SunriseIcon,
    color: 'from-orange-500 to-yellow-500',
    activities: ['Sunset arrival at Hard Rock Hotel Cancun', 'Welcome reception and opening keynote: "See Differently"', 'Informal "AI Curiosity Clinic" with faculty and AI experts', 'Meet your cohort and settle into the experience']
  }, {
    day: 'Day 1',
    title: 'See Differently & Strategy Foundations',
    duration: '16 hours',
    icon: BrainIcon,
    color: 'from-cyan-500 to-blue-500',
    activities: ['Morning: Mindset shifts, future-proof skills, job skill audit, competitive positioning', 'Afternoon: Redesign your workflow with AI and build your 90-day plan', 'Evening: Fireside stories from Stanford/INSEAD/Ivey faculty & practitioners', 'Live music and informal networking by the ocean']
  }, {
    day: 'Day 2',
    title: 'Build & Test (Lab Day)',
    duration: '16 hours',
    icon: BoxIcon,
    color: 'from-purple-500 to-pink-500',
    activities: ['Morning: Hands-on labs with OpenAI, Claude, Perplexity, Google, Microsoft, Cohere', 'Afternoon: Team-based prototype sprints (by industry and function)', 'Evening: Beachside demo night with informal pitches and feedback', 'Pool/ocean recharge blocks built into the schedule']
  }, {
    day: 'Day 3',
    title: 'Lead the Shift & Commit',
    duration: '12 hours',
    icon: TrophyIcon,
    color: 'from-green-500 to-emerald-500',
    activities: ['Morning: Leadership, governance, risk, and culture transformation', 'Afternoon: Capstone—each leader/team commits to 3 projects with owners and metrics', 'Closing: Graduation ceremony, cohort circle, and final Hard Rock experience', 'Depart with clarity, confidence, and a concrete plan']
  }];
  return <section className="py-24" data-id="element-91">
      <div className="max-w-7xl mx-auto px-6" data-id="element-92">
        <div className="text-center mb-16" data-id="element-93">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-94">
            The 48-Hour Experience in Cancun
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-95">
            3.5 days of intensive learning, building, and transformation at Hard
            Rock Hotel Cancun
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-8 mb-16" data-id="element-96">
          {timeline.map((day, index) => {
          const Icon = day.icon;
          return <div key={index} className="relative bg-slate-900/50 border border-slate-800 rounded-2xl p-8 hover:border-slate-700 transition-all duration-300" data-id="element-97">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-98">
                  <div className="flex-shrink-0" data-id="element-99">
                    <div className={`w-20 h-20 bg-gradient-to-br ${day.color} rounded-xl flex items-center justify-center mb-4`} data-id="element-100">
                      <Icon className="w-10 h-10 text-white" data-id="element-101" />
                    </div>
                    <div className="text-center" data-id="element-102">
                      <div className="text-2xl font-bold text-white" data-id="element-103">
                        {day.day}
                      </div>
                      <div className="text-sm text-slate-400" data-id="element-104">
                        {day.duration}
                      </div>
                    </div>
                  </div>

                  <div className="flex-1" data-id="element-105">
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-106">
                      {day.title}
                    </h3>
                    <div className="space-y-3" data-id="element-107">
                      {day.activities.map((activity, i) => <div key={i} className="flex items-start gap-3" data-id="element-108">
                          <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full mt-2 flex-shrink-0" data-id="element-109"></div>
                          <p className="text-slate-300" data-id="element-110">{activity}</p>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Work hard, swim harder */}
        <div className="bg-gradient-to-br from-cyan-900/30 to-blue-900/30 border border-cyan-500/30 rounded-2xl p-12 text-center" data-id="element-111">
          <h3 className="text-3xl font-bold text-white mb-4" data-id="element-112">
            Work Hard, Swim Harder
          </h3>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-6" data-id="element-113">
            Morning focus sessions. Afternoon pool and ocean recharge blocks.
            High-energy evenings with your cohort.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-slate-400" data-id="element-114">
            <div className="flex items-center gap-2" data-id="element-115">
              <div className="w-2 h-2 bg-cyan-400 rounded-full" data-id="element-116"></div>
              <span data-id="element-117">Intentionally small cohorts</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-118">
              <div className="w-2 h-2 bg-purple-400 rounded-full" data-id="element-119"></div>
              <span data-id="element-120">One cohort per month</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-121">
              <div className="w-2 h-2 bg-green-400 rounded-full" data-id="element-122"></div>
              <span data-id="element-123">High density of interaction</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}